import { useStaticQuery, graphql } from "gatsby"

const usePostsQuery = () => {
  return useStaticQuery(graphql`
    query PostssQuery {
      allWpPost {
        nodes {
          date
          title
          uri
          featuredImage {
            node {
              localFile {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    width: 1400
                  )
                }
              }
            }
          }
        }
      }
    }
  `)
}

export default usePostsQuery